var map = {
	"./widgets/common/go-url/go-url.component.html": 1008,
	"./widgets/common/ie-eleven-notification/ie-eleven-notification.component.html": 1009,
	"./widgets/common/language-switcher/language-switcher.component.html": 1010,
	"./widgets/products/all-usage/product-all-usage.component.html": 1011,
	"./widgets/products/segment-usage/product-segment-usage.component.html": 1012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1007;